export default __webpack_public_path__ + "static/media/picDiepPham.de091ca6.png";